<template>
  <layout-full>
    <router-view />
  </layout-full>
</template>

<script setup>
import LayoutFull from '@layouts/layout-full/LayoutFull.vue'
</script>
